import { RootState } from '~/store';

export const authorSubscribersSelector = (state: RootState) => state.authorSubscribers;
